<div>
  <h2>Top 10</h2>
  <ul class="list-group">
    @for (score of scoreboard?.scores; track score) {
      <li class="list-group-item d-flex align-items-start">
        <span class="badge bg-secondary rounded-pill me-3">{{ score.rank }}</span>
        <span class="flex-grow-1" [ngClass]="{'font-weight-bold': isLoggedInUser(score.user_id)}">{{ score.display_name }}</span>
        <span class="badge bg-secondary rounded-pill ms-auto">{{ score.points }} Pkt.</span>
        @if (markWinner && score.winner) {
          <div class="ms-2">
            <i class="bi bi-trophy-fill text-danger"></i>
          </div>
        }
      </li>
    }
  </ul>
</div>
